import React from 'react'
import {
  Badge,
  Card,
  CardHeader,
  CardBody
} from 'reactstrap'
import PropTypes from 'prop-types'
import TimeUtil from 'utils/time-util'
import StringUtil from 'utils/string-util'

const propTypes = {
  histories: PropTypes.arrayOf(PropTypes.shape({
    actor_type    : PropTypes.string,
    created_at    : PropTypes.string,
    latest_status : PropTypes.string,
    diff          : PropTypes.object,
    note          : PropTypes.string
  })),
  hiddenContents: PropTypes.array
}

const defaultProps = {
  histories: [ {
    actor_type    : '',
    created_at    : '',
    latest_status : '',
    diff          : {},
    note          : ''
  } ],
  hiddenContents: [ 'status', 'updated_at' ]
}

/**
 * show diff on each keys
 * @param {object} diffs
 * @param {array} hiddenContents
 */
const HistoryDiff = ({ diff, hiddenContents }) => {
  const keys = Object.keys(diff).filter((k) => !hiddenContents.includes(k))
  if (keys.length === 0) return null

  return keys.map((key, index) => (
    <span key={ index }>{ StringUtil.humanize(key) }: { Array.isArray(diff[key]) ? diff[key][1] : diff[key] } { index === keys.length-1 ? <br/> : null }</span>
  ))
}
HistoryDiff.propTypes = {
  diff           : PropTypes.object,
  hiddenContents : PropTypes.array
}

/**
 * note detail text
 * @param {string} note
 */
// eslint-disable-next-line react/prop-types
const HistoryNote = ({ note }) => {
  // eslint-disable-next-line react/prop-types
  let splittedNote = note.split(' by ')
  if (splittedNote.length > 1) splittedNote.pop()

  return <span>{ splittedNote.join() }</span>
}

/**
 * actor badge component
 * @param {object} history
 */
// eslint-disable-next-line react/prop-types
const ActorBadge = ({ history }) => {
  // eslint-disable-next-line react/prop-types
  const splittedNote = history.note.split(' by ')
  if (splittedNote.length < 2) return null

  return (
    // eslint-disable-next-line react/prop-types
    <Badge color={ badgeColor(history.actor_type) } pill>
      { splittedNote.pop() }
    </Badge>
  )
}

/**
 * get badge color based actor_type
 * @param {string} actorType | Customer, Admin
 */
const badgeColor = (actorType) => actorType && actorType === 'Customer' ? 'primary' : 'success'

// eslint-disable-next-line react/prop-types
const HistoryContent = ({ histories, hiddenContents }) => {
  // eslint-disable-next-line react/prop-types
  if (histories.length === 0) return (
    <div className='py-2 text-center'>
      <div className='mb-3'>
        <i className="fas fa-exclamation-triangle fa-3x"></i>
      </div>
            No histories available
    </div>
  )

  return (
    <div
      className="timeline timeline-one-side"
      data-timeline-axis-style="dashed"
      data-timeline-content="axis"
    >
      {
        // eslint-disable-next-line react/prop-types
        histories.map((history, index) => (
          <div className="timeline-block" key={ `timeline-${index}` }>
            <span className={ `timeline-step badge-${badgeColor(history.actor_type)}` }>
              <i className="ni ni-bell-55" />
            </span>
            <div className="timeline-content" >
              <small className="text-muted font-weight-bold">
                { TimeUtil.format(history.created_at, 'DD MMM YY HH:mm:ss') }
              </small>
              <h5 className="mt-3 mb-0">{ StringUtil.humanizeUpperCase(history.latest_status) }</h5>
              <p className="text-xs font-italic mt-1">
                <HistoryDiff
                  diff={ history.diff }
                  hiddenContents={ hiddenContents }
                />
              </p>
              <p className="text-sm text-monospace">
                <HistoryNote
                  note={ history.note }
                />
              </p>
              <div className="mt-3">
                <ActorBadge
                  history={ history }
                />
              </div>
            </div>
          </div>
        ))
      }
    </div>
  )}

/**
 * Show Order histories tp look alike timeline
 * @param {Array} histories - histories
 * @param {Array} hiddenContents - keys on the history content need to hide
 */
const CustomerOrderHistoryCard = ({ histories, hiddenContents }) => (
  <Card>
    <CardHeader>Histories</CardHeader>
    <CardBody>
      <HistoryContent
        histories={ histories }
        hiddenContents={ hiddenContents }
      />
    </CardBody>
  </Card>
)

CustomerOrderHistoryCard.propTypes    = propTypes
CustomerOrderHistoryCard.defaultProps = defaultProps

export default CustomerOrderHistoryCard